<template lang="html">
  <b-card style="padding:40px;">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    ></loading>

    <h5><b>LIST OF HOME DEALER</b></h5>
    <hr />
    <b-row>
      <b-form-group class="col-md-4">
        <label :for="`input-size`"
          >State <span class="danger-new"> *</span></label
        >
        <b-form-select
          v-model="form.state"
          :options="select.state"
          class="input-new"
          required
          @change="getUpline"
        ></b-form-select>
      </b-form-group>

      <b-form-group class="col-md-4" v-if="form.state !== ''">
        <label :for="`input-size`"
          >Stockist <span class="danger-new"> *</span></label
        >
        <b-form-select
          v-model="form.upline"
          :options="select.upline"
          class="input-new"
          required
          @change="getDataAll"
        ></b-form-select>
      </b-form-group>
    </b-row>
    <div v-if="items_sd.length >= 1">
      <b-card no-body>
        <b-tabs v-model="tabIndex" card>
          <b-tab title="Sub Dealer" active>
            <h5><b>Stockist</b></h5>
            <TableSubDealerIndex
              :fields="fields.stockist"
              :items="items"
              :type="type"
              :state="form.state"
              :stockist_id="form.upline"
            />

            <h5><b>Home Dealer</b></h5>
            <TableSubDealerIndex
              :fields="fields.stockist"
              :type="hd"
              :state="form.state"
              :stockist_id="form.upline"
              :filter="this.filter"
              :page="this.page"
              :email="this.email"
              :name="this.name"
              :tab="this.tab"
            />
          </b-tab>

          <b-tab title="Stockout">
            <TableStockOutByDay
              :type="`sub`"
              :state="form.state"
              :fields="fields.stockout"
              :id="form.upline"
              :filter="this.filter"
              :page="this.page"
              :date="this.date"
              :name="this.name"
              :outlet_name="this.outlet_name"
              :tab="this.tab"
            />
          </b-tab>

          <b-tab title="Purchase Order">
            <TablePurchaseOrderIndex
              :fields="fields.po"
              :state="form.state"
              :type="`sub`"
              :user_id="form.upline"
              :filter="this.filter"
              :page="this.page"
              :date="this.date"
              :name="this.name"
              :tab="this.tab"
            />
          </b-tab>

          <b-tab title="Delivery Order">
            <TableDeliveryOrderIndex
              :fields="fields.do"
              :state="form.state"
              :type="`sub`"
              :user_id="form.upline"
              :filter="this.filter"
              :page="this.page"
              :date="this.date"
              :name="this.name"
              :tab="this.tab"
            />
          </b-tab>

          <b-tab title="Monthly Forecast">
            <TableMonthlyForecastIndex
              :fields="fields.mf"
              :state="form.state"
              :type="`sub`"
              :user_id="form.upline"
              :filter="this.filter"
              :page="this.page"
              :name="this.name"
              :tab="this.tab"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </b-card>
</template>

<script>
import TableSubDealerIndex from "@/table/admin/subDealer/TableSubDealerIndex";
// import TableStockoutIndex from "@/table/admin/stockout/TableStockoutIndex";
import TableStockOutByDay from "@/table/user/subDealer/TableStockOutByDay";
import TableDeliveryOrderIndex from "@/table/admin/deliveryOrder/TableDeliveryOrderIndex";
import TablePurchaseOrderIndex from "@/table/admin/purchaseOrder/TablePurchaseOrderIndex";
import TableMonthlyForecastIndex from "@/table/admin/monthlyForecast/TableMonthlyForecastIndex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
export default {
  components: {
    TableSubDealerIndex,
    // TableStockoutIndex,
    TableDeliveryOrderIndex,
    TableStockOutByDay,
    TablePurchaseOrderIndex,
    TableMonthlyForecastIndex,
    Loading
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      tabIndex: 0,

      currentYear: moment().year(),
      currentMonth: moment().month() + 1,
      items: [],
      items_sd: [],
      items_stock: [],
      items_po: [],
      items_do: [],
      items_mf: [],

      type: "admin",
      hd: "hd",

      form: {
        state: "",
        upline: ""
      },

      tab: "0",

      select: {
        state: [{ value: "", text: "Please Select" }],
        upline: []
      },
      fields: {
        stockist: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Role",
            key: "role",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],
        stockout: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Outlet Name",
            key: "outlet_name",
            sortable: true
          },
          {
            label: "Category",
            key: "category",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],

        po: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],
        do: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ],

        mf: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Month",
            key: "month",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },

      filter: "",
      page: "",
      date: "",
      main_outlet_name: "",
      outlet_name: "",
      email: ""
    };
  },

  created() {
    this.getState();
    if (this.$route.query.state !== undefined) {
      this.form.state = parseInt(this.$route.query.state);
      this.getUpline();
      this.form.upline = parseInt(this.$route.query.stockist_id);
      this.getDataAll();
      this.tab = this.$route.query.tab;
      if (this.$route.query.filter !== undefined) {
        this.filter = this.$route.query.filter;
        this.page = this.$route.query.page;
        this.date = this.$route.query.date;
        this.email = this.$route.query.email;
        this.name = this.$route.query.name;
        this.outlet_name = this.$route.query.outlet_name;
      }
    }
  },

  methods: {
    getState() {
      this.$store.dispatch("getReftable", "state").then(res => {
        res.data.data.state.forEach(element => {
          this.select.state.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },

    getUpline() {
      this.form.upline = "";
      this.select.upline = [];
      this.select.upline.push({ value: "", text: "Please Select" });
      this.$store.dispatch("getUplineStock", this.form.state).then(res => {
        res.data.data.forEach(element => {
          this.select.upline.push({
            value: element.user_id,
            text: element.name
          });
        });
      });
    },

    getDataAll() {
      this.getStockistAdmin();
      this.getDownlineAdmin();
      this.getStockoutAdmin();
    },

    getStockistAdmin() {
      this.items = [];
      this.isLoading = true;
      this.$store
        .dispatch("showUser", { user_id: this.form.upline })
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            this.isLoading = false;
            this.items.push({
              name: res.data.data.name,
              role: res.data.data.access_lvl,
              id: this.form.upline
            });
          }
        });
    },

    getDownlineAdmin() {
      this.isLoading = true;
      this.items_sd = [];
      let data = {
        user_id: this.form.upline,
        page: 1
      };
      this.$store.dispatch("getDownlineAdmin", data).then(res => {
        if (res.data.response && res.data.response.code === 100) {
          this.isLoading = false;
          let no = 0;
          res.data.data.data.forEach(element => {
            no = no + 1;
            this.items_sd.push({
              no: no,
              name: element.name,
              role: element.access_lvl,
              id: element.user_id
            });
          });
        }
      });
    },

    getStockoutAdmin() {
      this.items_stock = [];
      this.isLoading = true;

      this.$store
        .dispatch("getStockoutSubDAdmin", { user_id: this.form.upline })
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            this.isLoading = false;
            let no = 0;
            res.data.data.data.forEach(element => {
              no = no + 1;
              let outletCat;
              if (element.outlet !== null) {
                outletCat = element.outlet.name;
              }

              let type = element.type === 1 ? "UHT" : "Pasteurized";
              this.items_stock.push({
                no: no,
                user_name: element.userdetails.name,
                name: element.outlet_name,
                category: outletCat,
                date: element.date,
                id: element.stock_id,
                pro_cat: type,
                type: element.type
              });
            });

            if (this.$route.query.tab && this.$route.query.tab === "2") {
              this.tabIndex = this.tabIndex + 1;
            }
            if (this.$route.query.tab && this.$route.query.tab === "3") {
              this.tabIndex = this.tabIndex + 2;
            }
            if (this.$route.query.tab && this.$route.query.tab === "4") {
              this.tabIndex = this.tabIndex + 3;
            }
            if (this.$route.query.tab && this.$route.query.tab === "5") {
              this.tabIndex = this.tabIndex + 4;
            }
          }
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
